<template>
  <div class="text-center">
    <v-progress-circular
      :rotate="-90"
      :size="100"
      :width="13"
      :value="value"
      color="primary"
    >
      {{ value }} %
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "ProfilInformationProgressCircle",
  props: {
    value: String,
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
